import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const chroma = defineConnector({
  identifier: "chroma",
  name: "Chroma",
  tagLine: "AI-native vector database",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://api\\.trychroma\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Chroma-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Chroma instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-instance.trychroma.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your authentication token",
      items: [
        {
          kind: "markdown",
          content:
            "Provide your Chroma authentication token. See the [docs](https://docs.trychroma.com/) for details on token auth setup.",
        },
        {
          kind: "input",
          label: "Auth token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/collections`,
  },
});
